import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PresenceWarningModalComponent } from '../../../app/components/presence-warning-modal/presence-warning-modal.component';
import { Nullable } from '../../common/domain/types/types';

export type PresenceModalResult = 'confirmed' | 'timeout' | 'dismissed';

@Injectable({
  providedIn: 'root',
})
export class PresenceModalService {
  private isOpen = false;
  private modal: Nullable<HTMLIonModalElement> = null;

  constructor(private readonly modalController: ModalController) {}

  public async closeWarningModal(): Promise<void> {
    if (!this.isOpen) {
      return;
    }

    if (!this.modal) {
      return;
    }

    await this.modal.dismiss(
      {
        confirmed: false,
      },
      'dismissed'
    );
  }

  public async openWarningModal(countdownSeconds: number): Promise<PresenceModalResult> {
    if (this.isOpen) {
      return 'dismissed';
    }

    this.isOpen = true;

    const modal = await this.modalController.create({
      component: PresenceWarningModalComponent,
      componentProps: {
        countdownSeconds,
      },
      backdropDismiss: false,
      canDismiss: (data: any, role?: string) => {
        return Promise.resolve(role === 'confirm' || role === 'logout' || role === 'timeout' || role === 'dismissed');
      },
      cssClass: 'user-presence-warning',
    });
    this.modal = modal;

    let timeoutId: number | null = null;

    try {
      await modal.present();
      const dismissPromise: Promise<PresenceModalResult> = modal.onDidDismiss().then((res) => {
        const confirmed = Boolean(res.data?.confirmed);
        if (confirmed) {
          return 'confirmed';
        }

        return 'dismissed';
      });

      const timeoutPromise: Promise<PresenceModalResult> = new Promise((resolve) => {
        timeoutId = window.setTimeout((): void => {
          resolve('timeout');
        }, countdownSeconds * 1000);
      });

      const result: PresenceModalResult = await Promise.race([dismissPromise, timeoutPromise]);

      if (result === 'timeout') {
        console.log(result);
        await modal.dismiss(
          {
            confirmed: false,
          },
          'timeout'
        );
      }

      return result;
    } finally {
      if (timeoutId !== null) {
        window.clearTimeout(timeoutId);
      }

      this.modal = null;
      this.isOpen = false;
    }
  }
}
